const GPT5_PREFIX = /^gpt-5/i;
const O_SERIES_PREFIX = /^o\d/i;

export const REASONING_SUMMARY_OPTIONS = ['auto', 'concise', 'detailed'];

export function isReasoningModel(model?: string | null): boolean {
    if (!model) return false;
    const normalized = model.trim().toLowerCase();
    return GPT5_PREFIX.test(normalized) || O_SERIES_PREFIX.test(normalized);
}

export function getReasoningEffortOptions(model?: string | null): string[] {
    if (!isReasoningModel(model)) {
        return [];
    }
    const normalized = (model ?? '').trim().toLowerCase();
    if (normalized === 'gpt-5-pro') {
        return ['high'];
    }
    if (normalized.startsWith('gpt-5.')) {
        return ['none', 'low', 'medium', 'high'];
    }
    // Remaining GPT-5 and o-series models support the standard set without "none".
    return ['minimal', 'low', 'medium', 'high'];
}

export function getReasoningEffortDefault(model?: string | null): string {
    if (!isReasoningModel(model)) {
        return 'none';
    }
    const normalized = (model ?? '').trim().toLowerCase();
    if (normalized === 'gpt-5-pro') {
        return 'high';
    }
    if (normalized.startsWith('gpt-5.')) {
        return 'none';
    }
    return 'medium';
}
